import logo from "../assets/logo.png";

export default function Portfolio({ keycloak }) {
  return (
    <div className="container">
      <section className="hero">
        <div className="portfolio-hero">
          <img
            src={logo}
            alt="Sistema Único - Imobiliárias"
            className="portfolio-logo"
          />
          <div>
            <h1>Portfólio do Projeto</h1>
            <p>
              O Sistema Único - Imobiliárias é um ERP imobiliário com foco em locação,
              automação financeira e busca por perfil. A arquitetura usa React
              no frontend, Java no backend, MongoDB e o protocolo MCP para
              padronizar a comunicação.
            </p>
            {keycloak && (
              <button
                className="btn-primary"
                type="button"
                onClick={() => keycloak.login()}
                style={{ marginTop: "1.5rem" }}
              >
                Entrar no Sistema
              </button>
            )}
          </div>
        </div>
      </section>

      <section className="grid grid-3">
        <div className="panel">
          <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🔍</div>
          <h3>Busca por IA</h3>
          <p>
            O usuário descreve o perfil do imóvel e o sistema retorna
            anúncios encontrados em portais externos com classificação
            semântica.
          </p>
        </div>
        <div className="panel">
          <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>💰</div>
          <h3>Financeiro Integrado</h3>
          <p>
            Geração de boletos e PIX, repasses automáticos para proprietários
            e indicadores de inadimplência e vacância.
          </p>
        </div>
        <div className="panel">
          <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🏢</div>
          <h3>Operação Imobiliária</h3>
          <p>
            Cadastros, contratos digitais, CRM para corretores e integração
            com WhatsApp e portais de anúncios.
          </p>
        </div>
      </section>

      <section>
        <h2 className="section-title">Funcionalidades Principais</h2>
        <div className="grid grid-3">
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>📄</div>
            <h3>Contratos Inteligentes</h3>
            <p>
              Gestão completa de contratos com geração automática, 
              reajustes programados, alertas de vencimento e renovação inteligente.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>💳</div>
            <h3>Cobrança Automatizada</h3>
            <p>
              Sistema de cobrança automática com geração de boletos e PIX,
              controle de inadimplência e repasses automáticos para proprietários.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>💬</div>
            <h3>Comunicação WhatsApp Direta</h3>
            <p>
              Integração direta com WhatsApp para envio de mensagens automáticas,
              notificações de vencimento e comunicação com locadores e locatários.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🔔</div>
            <h3>Lembretes Automáticos</h3>
            <p>
              Sistema de alertas e lembretes automáticos para vencimentos de contratos,
              reajustes, vistorias e manutenções programadas.
            </p>
          </div>
          <div className="panel">
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>📊</div>
            <h3>Dashboards</h3>
            <p>
              Dashboards completos com métricas financeiras, indicadores de performance,
              gráficos de inadimplência e análise de vacância de imóveis.
            </p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Planos e Preços</h2>
        <div className="grid grid-3" style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div className="panel" style={{ 
            textAlign: "center",
            padding: "2rem 1.5rem",
            border: "2px solid var(--border)"
          }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🆓</div>
            <h3 style={{ marginBottom: "0.5rem" }}>Gratuito</h3>
            <div style={{ 
              fontSize: "2rem", 
              fontWeight: 700, 
              color: "var(--brand-blue)",
              marginBottom: "1rem"
            }}>
              R$ 0,00
            </div>
            <div style={{ 
              color: "var(--text-secondary)",
              marginBottom: "1.5rem",
              fontSize: "0.9rem"
            }}>
              1 contrato
            </div>
            <ul style={{ 
              textAlign: "left", 
              listStyle: "none", 
              padding: 0,
              margin: "1.5rem 0",
              color: "var(--text-secondary)"
            }}>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Gestão básica de contratos
              </li>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Cadastro de locadores e locatários
              </li>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Busca inteligente de imóveis
              </li>
            </ul>
            {keycloak ? (
              <button 
                className="btn-secondary" 
                onClick={() => keycloak.login()}
                style={{ width: "100%" }}
              >
                Começar Grátis
              </button>
            ) : (
              <button 
                className="btn-secondary" 
                disabled
                style={{ width: "100%" }}
              >
                Em breve
              </button>
            )}
          </div>

          <div className="panel" style={{ 
            textAlign: "center",
            padding: "2rem 1.5rem",
            border: "2px solid var(--brand-blue)",
            background: "linear-gradient(135deg, rgba(0, 86, 179, 0.05) 0%, rgba(34, 139, 34, 0.05) 100%)",
            position: "relative",
            transform: "scale(1.05)"
          }}>
            <div style={{ 
              position: "absolute",
              top: "-12px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "linear-gradient(135deg, var(--brand-blue), var(--brand-green))",
              color: "#ffffff",
              padding: "0.25rem 1rem",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 600
            }}>
              MAIS POPULAR
            </div>
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>⭐</div>
            <h3 style={{ marginBottom: "0.5rem" }}>Básico</h3>
            <div style={{ 
              fontSize: "2rem", 
              fontWeight: 700, 
              color: "var(--brand-blue)",
              marginBottom: "1rem"
            }}>
              R$ 49,90
            </div>
            <div style={{ 
              color: "var(--text-secondary)",
              marginBottom: "1.5rem",
              fontSize: "0.9rem"
            }}>
              Até 10 contratos
            </div>
            <ul style={{ 
              textAlign: "left", 
              listStyle: "none", 
              padding: 0,
              margin: "1.5rem 0",
              color: "var(--text-secondary)"
            }}>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Tudo do plano Gratuito
              </li>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Cobrança automatizada
              </li>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                WhatsApp integrado
              </li>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Dashboards completos
              </li>
            </ul>
            {keycloak ? (
              <button 
                className="btn-primary" 
                onClick={() => keycloak.login()}
                style={{ width: "100%" }}
              >
                Assinar Agora
              </button>
            ) : (
              <button 
                className="btn-primary" 
                disabled
                style={{ width: "100%" }}
              >
                Em breve
              </button>
            )}
          </div>

          <div className="panel" style={{ 
            textAlign: "center",
            padding: "2rem 1.5rem",
            border: "2px solid var(--border)"
          }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🚀</div>
            <h3 style={{ marginBottom: "0.5rem" }}>Profissional</h3>
            <div style={{ 
              fontSize: "2rem", 
              fontWeight: 700, 
              color: "var(--brand-green)",
              marginBottom: "1rem"
            }}>
              R$ 119,90
            </div>
            <div style={{ 
              color: "var(--text-secondary)",
              marginBottom: "1.5rem",
              fontSize: "0.9rem"
            }}>
              Até 30 contratos
            </div>
            <ul style={{ 
              textAlign: "left", 
              listStyle: "none", 
              padding: 0,
              margin: "1.5rem 0",
              color: "var(--text-secondary)"
            }}>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Tudo do plano Básico
              </li>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Suporte prioritário
              </li>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                Relatórios avançados
              </li>
              <li style={{ marginBottom: "0.75rem", paddingLeft: "1.5rem", position: "relative" }}>
                <span style={{ position: "absolute", left: 0 }}>✓</span>
                API personalizada
              </li>
            </ul>
            {keycloak ? (
              <button 
                className="btn-secondary" 
                onClick={() => keycloak.login()}
                style={{ width: "100%" }}
              >
                Assinar Agora
              </button>
            ) : (
              <button 
                className="btn-secondary" 
                disabled
                style={{ width: "100%" }}
              >
                Em breve
              </button>
            )}
          </div>
        </div>

        <div style={{ 
          textAlign: "center", 
          marginTop: "2rem",
          padding: "2rem",
          background: "var(--surface)",
          borderRadius: "var(--radius-lg)",
          border: "1px solid var(--border)"
        }}>
          <h3 style={{ marginBottom: "0.5rem" }}>Condomínio</h3>
          <p style={{ color: "var(--text-secondary)", marginBottom: "1rem" }}>
            Acima de 30 contratos
          </p>
          <div style={{ 
            fontSize: "1.5rem", 
            fontWeight: 700, 
            color: "var(--brand-blue)",
            marginBottom: "1rem"
          }}>
            R$ 5/unidade/mês
          </div>
          <p style={{ color: "var(--text-secondary)", marginBottom: "1.5rem" }}>
            Solução completa para administração de condomínios com cobrança automatizada via PIX, 
            cartão e automática. Inclui recuperação de crédito (10% do valor recuperado) e 
            negativação automática de inadimplentes.
          </p>
          {keycloak ? (
            <button 
              className="btn-secondary" 
              onClick={() => keycloak.login()}
            >
              Falar com Vendas
            </button>
          ) : (
            <button 
              className="btn-secondary" 
              disabled
            >
              Em breve
            </button>
          )}
        </div>
      </section>
    </div>
  );
}
